import { currentLanguage } from "../../algorithms/storage";
import axios from "../axiosConfig";

export const getAllLinks = (data, token) => {
  return axios.post("ExpRelatedWebsite/GetAll", data, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getAllAgenda = (data, pageSize, pageNumber, token) => {
  return axios.post(`Agenda/GetAll/${pageNumber}/${pageSize}`, data, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const addLink = (data, token) => {
  return axios.post(`ExpRelatedWebsite/AddRealtedSite`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const addAgenda = (data, token) => {
  return axios.post(`Agenda/AddAgenda`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateLink = (data, token) => {
  return axios.post(`ExpRelatedWebsite/EditRelatedSite`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const updateAgenda = (data, token) => {
  return axios.post(`Agenda/EditAgenda`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const deleteLink = (data, token) => {
  return axios.post(`ExpRelatedWebsite/DeleteSite`, data, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const deleteAgenda = (data, token) => {
  return axios.post(`Agenda/DeleteAgenda`, data, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getLink = (id, token) => {
  return axios.get(`ExpRelatedWebsite/GetById/${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getAgenda = (id, token) => {
  return axios.get(`Agenda/GetById/${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
